
export class ColorManager {    

    counter = 0;

    GetNextColor() {
        if(this.counter >= color_scheme.length)
            this.counter=0;

        return color_scheme[this.counter++];
    }
}

const  color_scheme = [   

        '#63B8FF',
    '#00CED1',
    '#AEEEEE',
    '#D1EEEE',
    '#87CEFF',
    '#8DB6CD',
    '#4682B4',
    '#00BFFF',
    '#00E5EE',
    '#7A8B8B',
    '#008B8B',
    '#5CACEE',
    '#53868B',
    '#AFEEEE',
    '#98F5FF',
    '#36648B',
    '#00868B',
    '#7FFFD4',
    '#BCD2EE',
    '#E0EEEE',
    '#4A708B',
    '#68838B',
    '#7B68EE',
    '#0000EE',
    '#1874CD',
    '#483D8B',
    '#B2DFEE',
    '#F0F8FF',
    '#87CEFA',
    '#7EC0EE',
    '#76EEC6',
    '#7A67EE',
    '#E0FFFF',
    '#B4CDCD',
    '#458B74',
    '#CAE1FF',
    '#00EEEE',
    '#436EEE',
    '#00688B',
    '#4876FF',
    '#48D1CC',
    '#0000CD',
    '#8A2BE2',
    '#4169E1',
    '#6A5ACD',
    '#00F5FF',
    '#473C8B',
    '#607B8B',
    '#A4D3EE',
    '#BFEFFF',
    '#8470FF',
    '#3A5FCD',
    '#A2B5CD',
    '#C1CDCD',
    '#00FFFF',
    '#40E0D0',
    '#9AC0CD',
    '#1E90FF',
    '#27408B',
    '#4F94CD',
    '#66CDAA',
    '#8EE5EE',
'#000080',
    '#BBFFFF',
    '#0000FF',
    '#ADD8E6',
    '#104E8B',
    '#87CEEB',
    '#191970',
    '#B0C4DE',
    '#6495ED',
    '#009ACD',
    '#836FFF',
    '#6E7B8B',
    '#6959CD',
    '#7AC5CD',
    '#B0E2FF',
    '#668B8B',
    '#00CDCD',
    '#1C86EE',
    '#838B8B',
    '#00C5CD',
    '#00B2EE',
    '#00008B',
    '#6CA6CD',
    '#96CDCD',
    '#B0E0E6',
    '#F0FFFF',
    '#5F9EA0',


]